import { render, staticRenderFns } from "./RequestTabHeader.vue?vue&type=template&id=4a4a8300"
import script from "./RequestTabHeader.vue?vue&type=script&lang=js"
export * from "./RequestTabHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports